module.exports = __webpack_public_path__ + "img/9-2.2c881c7d.png";